import { v4 as uuidv4 } from 'uuid';
import { FieldModel } from './field';
import { CultureTextModel } from './form';

export interface SectionModel {
  id: string;
  name: CultureTextModel[] | string;
  multiple: boolean;
  visible: boolean;
  sectionsFormik?: SectionModel[];
  multipleValidations?: SectionMultipleValidationModel;
  fields: Array<FieldModel>;
}

export interface SectionMultipleValidationModel {
  min: number | undefined;
  max: number | undefined;
}

export class Section {
  public id: string;
  public name: CultureTextModel[] | string;
  public multiple: boolean;
  public visible: boolean;
  public sectionsFormik: SectionModel[] | undefined;
  public multipleValidations: SectionMultipleValidationModel | undefined;
  public fields: Array<FieldModel>;

  constructor(name: string) {
    this.id = uuidv4();
    this.name = name;
    this.multiple = false;
    this.fields = [];
    this.visible = true;
  }
}
